import getProductStatus from "components/Pages/Finance/_hook/getProductStatus";

export default (financialProducts) => {
  let selectProduct;
  let apyMax = 0;
  financialProducts.map((productObj) => {
    const { disabled } = getProductStatus(productObj);
    if (disabled) return;
    let apy = 0;
    productObj.apyList && productObj.apyList.map((obj) => {
      obj.annualized > apy && (apy = obj.annualized);
    });
    if (apy > apyMax) {
      selectProduct = productObj;
      apyMax = apy;
    }
  });

  return selectProduct || financialProducts[0];
};
